import React, { useState, useEffect } from 'react';
import HeadingArea from '../../general/HeadingArea';
import { FaCheck } from 'react-icons/fa';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { AiOutlinePlusCircle, AiOutlineMinusCircle } from 'react-icons/ai';
import { RiDeleteBin6Line } from 'react-icons/ri';

const Lesson = ({ setLoading, userData }) => {
  const [classes, setClasses] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState('');
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState('');
  const [titles, setTitles] = useState(['']); // Dynamic title inputs
  const [response2, setResponse2] = useState({ message: '', status: '' });
  const [myLesson, setMyLesson] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState([]);

  // Fetch Classes
  const fetchClasses = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-classes');
      if (response.ok) {
        const data = await response.json();
        setClasses(data);
      } else {
        console.error('Failed to fetch class');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch Assigned Subjects
  const fetchAssignSubject = async (classId) => {
    if (!classId) return;
    setLoading(true);
    try {
      const res = await fetch(`https://api.kcian.in/fetch-assigned-subject?class_id=${classId}`);
      if (res.ok) {
        const data = await res.json();
        if (data.length > 0) {
          const uniqueSubjectsMap = new Map();
          data.forEach(item => {
            if (!uniqueSubjectsMap.has(item.sub_id)) {
              uniqueSubjectsMap.set(item.sub_id, item);
            }
          });
          const uniqueSubjects = Array.from(uniqueSubjectsMap.values());
          setSubjects(uniqueSubjects);
          setResponse2({ message: 'Subjects Loaded.', status: 'success' });
        } else {
          setSubjects([]);
          setResponse2({ message: 'No subjects assigned to this class.', status: 'error' });
        }
      } else {
        setSubjects([]);
        setResponse2({ message: 'Error fetching subjects.', status: 'error' });
      }
    } catch (error) {
      console.error('Error fetching assigned subjects:', error);
    } finally {
      setLoading(false);
      setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    }
  };

  // Handlers for dynamic titles
  const addTitleField = () => setTitles([...titles, '']);
  const removeTitleField = (index) => setTitles(titles.filter((_, i) => i !== index));
  const handleTitleChange = (index, value) => {
    const newTitles = [...titles];
    newTitles[index] = value;
    setTitles(newTitles);
  };

  // Handle Save
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedClassId || !selectedSubject || titles.some(title => !title.trim())) {
      setResponse2({ message: 'All fields are required.', status: 'error' });
      return;
    }

    const payload = titles.map(title => ({
      class_id: selectedClassId,
      subject_id: selectedSubject,
      title: title.trim(),
      added_by: userData.user_id
    }));

    try {
      setLoading(true);
      const res = await fetch('https://api.kcian.in/add-lesson-plan', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        setResponse2({ message: 'Lesson(s) Added Successfully.', status: 'success' });
        setTitles(['']);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
      }
    } catch (err) {
      console.error('Save error:', err);
    } finally {
      setLoading(false);
      setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    }
  };

  // Effects
  useEffect(() => {
    fetchClasses();
  }, []);

  useEffect(() => {
    if (selectedClassId) {
      fetchAssignSubject(selectedClassId);
    } else {
      setSubjects([]);
    }
  }, [selectedClassId]);


  const fetchLesson = async () => {
  if (!selectedClassId || !selectedSubject) {
    setResponse2({ message: 'Please select Class and Subject before searching', status: 'error' });
    return;
  }

  try {
    setLoading(true);
    const res = await fetch(`https://api.kcian.in/fetch-lesson-plan?class_id=${selectedClassId}&sub_id=${selectedSubject}`);

    if (res.ok) {
      const data = await res.json();
      console.log(data);

      if(data.length > 0){
setMyLesson(data);
      setResponse2({ message: 'Lesson Plan Fetched Successfully', status: 'success' });
      }
      else {
        setMyLesson([]);
        setResponse2({ message: 'No Lesson Plan Added to this Class & Subject.', status: 'error' });
      }
    } else {
      setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
    }
  } catch (error) {
    console.error('Fetch plan error:', error);
  } finally {
    setLoading(false);
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
  }
};


const handleShowDelete = (cls) => {
    setSelectedPlan(cls);
    setShowDelete(true);
}


              const handleDelete = async (lsnId) => {
    try {
      const response = await fetch(`https://api.kcian.in/delete-lesson-plan/${lsnId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setMyLesson((prevData) => prevData.filter((product) => product.id !== lsnId));
        setShowDelete(false);
        setResponse2({ message: 'Plan Removed successfully!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
      }
    } catch (error) {
      console.error('Error deleting fee particular:', error);
    }
  };



  return (
    <>
    <section className="py-4">
      <div className="px-4">
        <HeadingArea message1="Lesson Plan" message2="Lesson" />
        {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

        <div className='row'>
          {/* Left Side Form */}
          <div className='col-xl-3 col-lg-4 col-md-5 col-12 my-2'>
            <form onSubmit={handleSubmit}>
              <div className="profile-card">
                <p className="profile-heading">Add Lesson</p>

                <div className='profile-input-area'>
                  <label className='profile-badge'>Class</label>
                  <select
                    className='profile-input'
                    value={selectedClassId}
                    onChange={(e) => setSelectedClassId(e.target.value)}
required
>
                    <option value=''>-- Select Class --</option>
                    {classes.map(cls => (
                      <option key={cls.id} value={cls.id}>
                        {cls.class_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className='profile-input-area mt-4'>
                  <label className='profile-badge'>Subject</label>
                  <select
                    className='profile-input'
                    value={selectedSubject}
                    onChange={(e) => setSelectedSubject(e.target.value)}
                    disabled={subjects.length === 0}
                    required
                  >
                    <option value=''>-- Select Subject --</option>
                    {subjects.map(sub => (
                      <option key={sub.id} value={sub.sub_id}>
                        {sub.sub_name} ({sub.sub_type}) ({sub.sub_code})
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className='profile-card mt-2'>
                <p className='profile-heading'>Add Lesson Name</p>

                {titles.map((title, index) => (
                  <div className="mb-3 d-flex align-items-center" key={index}>
                    <div className='profile-input-area w-100'>
                    <input
                      type="text"
                      value={title}
                      onChange={(e) => handleTitleChange(index, e.target.value)}
                      placeholder="Enter Lesson Title"
                      className="profile-input"
                      required
                    />
                    </div>
                    {titles.length > 1 && (
                      <AiOutlineMinusCircle
                        size={26}
                        className="text-danger cursor-pointer ms-2"
                        onClick={() => removeTitleField(index)}
                      />
                    )}
                  </div>
                ))}

                <div className='text-end'>
                  <button
                    type="button"
                    className="border-0 bg-transparent cursor-pointer"
                    onClick={addTitleField}
                  >
                    <AiOutlinePlusCircle size={26} />
                  </button>
                </div>

                <div className='text-center'>
                  <button type='submit' className='profile-btn'>
                    <FaCheck /> Save
                  </button>
                </div>
              </div>
            </form>
          </div>

          {/* Right Side List (Demo Table) */}
          <div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100'>
            <div className='profile-card'>
              <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
                <span className="profile-heading me-3">Lesson List</span>

<button className='profile-btn2' onClick={() => fetchLesson()}>Fetch Lesson</button>
                {/* <div className='profile-input-area ms-auto col-lg-3 border-0'>
                  <input
                    type='text'
                    name='search'
                    className='profile-input border-bottom rounded-0'
                    placeholder='Search...'
                  />
                </div> */}
              </div>

              <div className='table-responsive mt-4'>
                <table className='w-100'>
                  <thead className='account-thead'>
                    <tr>
                      <th className='rounded-start-4'>S No</th>
                      <th>Class</th>
                      <th>Subject</th>
                      <th>Lesson</th>
                      {/* {userData.role == 'SupAdmin' && */}
                      <th>Added By</th>
                      <th className='rounded-end-4'>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {myLesson.map((lsn, index) => (
                    <tr className='account-tr'>
                      <td>{index + 1}</td>
                      <td>{lsn.class_name}</td>
                      <td>{lsn.sub_name}({lsn.sub_type})</td>
                      <td>{lsn.lesson_name}</td>
                                            {/* {userData.role == 'SupAdmin' && */}
                      <td>{lsn.addedby_name} ({lsn.designation})</td>
{(userData.role == 'SupAdmin' || userData.user_id == lsn.added_by) 
?    <td><RiDeleteBin6Line className='account-icon2' title='Remove' onClick={() => handleShowDelete(lsn)} /></td>
    : <td>--</td>}
                    </tr>
                    ))}

                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>


          {showDelete && (
  <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove This Lesson Plan!</p>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Class</th>
    <th>Subject</th>
    <th className='rounded-end-4'>Lesson</th>
</thead>

<tr className='account-tr'>
                      <td>{selectedPlan.class_name}</td>
                      <td>{selectedPlan.sub_name}({selectedPlan.sub_type})</td>
                      <td>{selectedPlan.lesson_name}</td></tr>

</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Lesson & its Topics will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedPlan.id)}>Remove</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
  </>
)}

    </>
  );
};

export default Lesson;
